export const POST_RANKINGS = 'post_rankings'
